// extracted by mini-css-extract-plugin
export default {"img":"PreviewImage_img__MoKx0"};